var _excluded = ["endIcon", "label", "startIcon"];
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import PropTypes from 'prop-types';
import StyledTag, { StyledEndIcon, StyledStartIcon } from './Tag.styled';
function Tag(_ref) {
  var endIcon = _ref.endIcon,
    label = _ref.label,
    startIcon = _ref.startIcon,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/React.createElement(StyledTag, rest, startIcon && /*#__PURE__*/React.createElement(StyledStartIcon, null, startIcon), label, endIcon && /*#__PURE__*/React.createElement(StyledEndIcon, null, endIcon));
}
Tag.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Defines the color of component
   */
  color: PropTypes.oneOf(['default', 'primary', 'primaryAlt', 'secondary', 'secondaryAlt', 'tertiary', 'error', 'warning', 'success', 'info']),
  /**
   *  Defines the shape of component edges
   */
  edges: PropTypes.oneOf(['default', 'rounded', 'sharp', 'smooth']),
  /**
   * Element placed before the children.
   */
  endIcon: PropTypes.node,
  /**
   * Text to display in component
   */
  label: PropTypes.node.isRequired,
  /**
   * Size of the component
   */
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  /**
   * Element placed after the children.
   */
  startIcon: PropTypes.node,
  /**
   * The variant to use.
   */
  variant: PropTypes.oneOf(['outlined', 'solid'])
} : {};
Tag.defaultProps = {
  color: 'secondaryAlt',
  edges: 'default',
  endIcon: undefined,
  size: 'medium',
  variant: 'solid',
  startIcon: undefined
};
export default Tag;